import { Component, OnInit } from '@angular/core';
import { faLink } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss']
})
export class HomeContentComponent implements OnInit {
  faLink = faLink;

  constructor() { }

  ngOnInit() {
  }

  goToGoogle() {
    window.location.href = "";

  }
  goToApple() {
    window.location.href = "";
  }
}
